import { Route, RawLocation } from "vue-router";
import store from "@/shared/store";
import { getClassifiedId } from "../../ClassifiedsApi";
import { authenticate } from "../../Authenticate";
import { i18n } from "../translation/i18n";
import { getExtendSteps, getSteps, getVisibilitySteps } from "@/encoding/scripts/steps";
import { Step } from "@/shared/interfaces/Step.interface";
import { validationClassified } from "../../ValidateData";

// Make sure app URL looks correct before `#` (/classifieds/#)
const redirectBadRoot = async (to: Route, from: Route, next: (to?: RawLocation | false | void) => void): Promise<string | void> => {
    const path = window.location.pathname;

    if (path === "/classifieds/" || path === "/classifieds") {
        return next();
    }

    window.location.href = window.location.href.replace(path, "/classifieds/");
};

// Get the classified when we want to extend it
const guardRetrieveClassified = async (to: Route, from: Route, next: (to?: RawLocation | false | void) => void): Promise<string | void> => {
    const classifiedId = to.params.id;

    if(!store.getters["UserModule/getUser"]) {
        authenticate();
    }
    getClassifiedId(classifiedId).then((res) => {
        if(!res) {
            const urlTranslated = i18n.t("route-welcome") as string;
            next(urlTranslated);
        } else {
            next();
        }
    });
};

const setStepsWizard = async function(stepName: string): Promise<true> {
    let isStepPresent = getExtendSteps().steps.filter((step: Step) => {
        return step.step === stepName;
    })[0];

    if(isStepPresent) {
        store.dispatch("StepsWizard/init", {config: getExtendSteps()});
        return Promise.resolve(true);
    }

    isStepPresent = getVisibilitySteps().steps.filter((step: Step) => {
        return step.step === stepName;
    })[0];

    if(isStepPresent) {
        store.dispatch("StepsWizard/init", {config: getVisibilitySteps()});
        return Promise.resolve(true);
    }

    store.dispatch("StepsWizard/init", {config: getSteps()});
    return Promise.resolve(true);    
};

const RouterHelper = {
    guardToStepRoute: async function(to: Route, from: Route, next: (to?: RawLocation | false | void) => void): Promise<string|void> {
        await setStepsWizard(to.name ? to.name : "");
        const classifiedId = to.params.id;
        const routeWelcome = i18n.t("route-welcome") as string;
        const userAuthenticated = store.getters["UserModule/getUser"] ? store.getters["UserModule/getUser"] : authenticate();
        if(userAuthenticated) {
            if(classifiedId) {
                const classified = await getClassifiedId(classifiedId);
                if(classified) {
                    if(to.name && ["step-payment", "step-pricing"].includes(to.name)) {
                        validationClassified((success:boolean) => {
                            if(success) {
                                next();
                            } else {
                                const urlTranslated = i18n.t("step-contact-information") as string;
                                next(urlTranslated + classifiedId);
                            }
                        });
                    } else {
                        validationClassified(() => {
                            next();
                        });
                    }
                } else {
                    next(routeWelcome);
                }
            } else {
                if(to.name && to.name !== "step-property-type") {
                    const urlTranslated = i18n.t("step-property-type") as string;
                    next(urlTranslated);
                } else {
                    next();
                }
            }
        } else {
            next(routeWelcome);
        }
    },
    guardRetrieveClassified: guardRetrieveClassified,
    redirectBadRoot: redirectBadRoot,
};

export { RouterHelper };
